import React from 'react';
import {useSelector} from "react-redux";
import {get} from 'lodash';

import Graph from './Graph';

export default function ({printable, dataType, student_name}) {

    return (
        <div className="">
            <Graph
                printable={printable}
                dataType={dataType}
                student_name={student_name}
            />
        </div>
    );
}
